import { render, staticRenderFns } from "./LogsSecurityList.vue?vue&type=template&id=b765d960&"
import script from "./LogsSecurityList.vue?vue&type=script&lang=js&"
export * from "./LogsSecurityList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports